module.exports = __webpack_public_path__ + "img/more-chat.aa157ec7.svg";